function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1_Profile",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-108.000000, -353.000000)",
  fill: "#2E2E2E",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M118.5,363.5 C115.600505,363.5 113.25,361.149495 113.25,358.25 C113.25,355.350505 115.600505,353 118.5,353 C121.399495,353 123.75,355.350505 123.75,358.25 C123.75,361.149495 121.399495,363.5 118.5,363.5 Z M118.5,361.4 C120.239697,361.4 121.65,359.989697 121.65,358.25 C121.65,356.510303 120.239697,355.1 118.5,355.1 C116.760303,355.1 115.35,356.510303 115.35,358.25 C115.35,359.989697 116.760303,361.4 118.5,361.4 Z M112.2,365.6 L124.8,365.6 C127.119596,365.6 129,367.480404 129,369.8 L129,372.95 C129,373.529899 128.529899,374 127.95,374 L109.05,374 C108.470101,374 108,373.529899 108,372.95 L108,369.8 C108,367.480404 109.880404,365.6 112.2,365.6 Z M112.2,367.7 C111.040202,367.7 110.1,368.640202 110.1,369.8 L110.1,371.9 L126.9,371.9 L126.9,369.8 C126.9,368.640202 125.959798,367.7 124.8,367.7 L112.2,367.7 Z",
  id: "profile"
})));

var SvgProfile = function SvgProfile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProfile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/profile.7c12a2fb.svg";
export { ForwardRef as ReactComponent };